// Tek kullanımlık şifre ile giriş yapan kullanıcı kalıcı şifresini belirlemeden devam edemez
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ForcePasswordChange = () => {
  const { user, refreshUser, logout } = useAuth();
  const [f, setF] = useState({ current: '', next: '', again: '' });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.again) { toast.error('Yeni şifreler aynı değil'); return; }
    setBusy(true);
    try {
      await axios.put(`${API}/auth/change-password`, { current_password: f.current, new_password: f.next });
      toast.success('Şifreniz belirlendi');
      await refreshUser();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : d?.[0]?.msg?.replace('Value error, ', '') || 'Şifre değiştirilemedi');
    } finally { setBusy(false); }
  };
  const field = (k, label, testId) => (
    <div className="space-y-1.5"><Label>{label}</Label><Input type="password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} required data-testid={testId} /></div>
  );
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-2xl border bg-white p-8 shadow-sm">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-100"><KeyRound className="h-5 w-5 text-orange-600" /></span>
          <div><h1 className="text-xl font-bold text-slate-900">Kalıcı şifrenizi belirleyin</h1><p className="text-sm text-slate-500">{user?.email}</p></div>
        </div>
        <p className="text-sm text-slate-600">Güvenliğiniz için e-postanıza gelen tek kullanımlık şifreyi kendi belirleyeceğiniz bir şifre ile değiştirin. Şifre en az 8 karakter olmalı, harf ve rakam içermelidir.</p>
        {field('current', 'Tek kullanımlık şifre', 'force-pw-current')}
        {field('next', 'Yeni şifre', 'force-pw-new')}
        {field('again', 'Yeni şifre (tekrar)', 'force-pw-again')}
        <Button type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-slate-800" data-testid="force-pw-submit">{busy ? 'Kaydediliyor...' : 'Şifremi Belirle ve Devam Et'}</Button>
        <button type="button" onClick={logout} className="w-full text-center text-sm text-slate-500 hover:text-slate-800" data-testid="force-pw-logout">Çıkış yap</button>
      </form>
    </div>
  );
};
